import * as actionTypes from "./actionTypes";
import instance from "../axios-base";
import { setLoader, unSetLoader } from "./appActions";
import { SignJWT } from "jose";

const secret = new TextEncoder().encode(
  "61097f1e7c780398805b43f667a4af4224f54ac689d169cb1b9f7ce59642a071"
);

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (authData) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    authData: authData,
    error: null,
  };
};

export const authFailed = (error) => {
  return {
    type: actionTypes.AUTH_FAILED,
    error: "Authentication Failed",
    authData: null,
  };
};

export const auth = (email, password, isSignUp) => {
  return async (dispatch) => {
    try {
      const user_details = await new SignJWT({
        email_id: email,
        password: password,
      })
        .setProtectedHeader({ alg: "HS256" })
        .setExpirationTime("5m")
        .sign(secret);
      console.log("user_details: ", user_details);
      dispatch(setLoader());
      let response = await instance({
        url: "/auth/doLogin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: { user_details },
      });
      let { data } = response.data;
      data["email"] = email;
      data["loginTime"] = new Date();
      data["full_name"] = data.first_name + " " + data.last_name;
      data["isAdmin"] = data.groups.reduce(
        (acc, curr) => acc || curr.GroupName === "SuperAdminGroup",
        false
      );
      if (data.practices.length === 1) {
        data["selected_practice"] = data.practices[0]["practice_id"];
        data["selected_practice_name"] = data.practices[0]["practice_name"];
        data["practice_details"] = data.practices[0];
      } else {
        data["selected_practice"] = null;
      }
      dispatch(authSuccess(data));
      dispatch(unSetLoader());
      if (typeof window !== "undefined") {
        localStorage.setItem("email_id", email);
        localStorage.setItem("auth_data", JSON.stringify(data));
      }
      return data;
    } catch (error) {
      dispatch(unSetLoader());
      dispatch(authFailed(error));
    }
  };
};

export const refreshToken = (data) => {
  return async (dispatch) => {
    try {
      const response = await instance({
        url: "/auth/refreshToken",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data,
      });
      const auth_data = await isAuthenticated();
      auth_data["loginTime"] = new Date();
      auth_data["access_token"] = response.data.data.access_token;
      auth_data["id_token"] = response.data.data.id_token;
      dispatch(authSuccess(auth_data));
      if (typeof window !== "undefined") {
        localStorage.setItem("auth_data", JSON.stringify(auth_data));
      }
    } catch (error) {
      console.log("ERROR WHILE SENDING REFRESH TOKEN: ", error);
      // dispatch(authFailed(error))
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    try {
      // let response = await instance({
      //     url: "/auth/logout",
      //     method: "POST",
      //     headers: {
      //         "Content-Type": "application/json"
      //     }
      // });
      if (typeof window !== "undefined") {
        localStorage.removeItem("auth_data");
      }
      dispatch({ type: actionTypes.LOGOUT });
      dispatch({ type: actionTypes.CLEAR_CHARGE_ENTRY });
      dispatch({ type: actionTypes.CLEAR_DASHBOARD });
      dispatch({ type: actionTypes.CLEAR_ERA });
    } catch (error) {
      console.log("ERROR", error);
      if (typeof window !== "undefined") {
        localStorage.removeItem("auth_data");
      }
    }
  };
};

export const selectPractice = (id, name, practiceData) => {
  const practice_id = parseInt(id);
  return async (dispatch) => {
    dispatch({
      type: actionTypes.SET_PRACTICE_ID,
      id: practice_id,
      payload: practiceData,
    });
    let data = isAuthenticated();
    data["selected_practice"] = practice_id;
    data["selected_practice_name"] = name;
    data["practice_details"] = practiceData;
    dispatch(authSuccess(data));
    if (typeof window !== "undefined") {
      localStorage.setItem("auth_data", JSON.stringify(data));
    }
  };
};

export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (localStorage.getItem("auth_data")) {
    return JSON.parse(localStorage.getItem("auth_data"));
  } else {
    return false;
  }
};
